"use client";

import { createContext, useContext } from "react";

export type ClassDetailsType = {
  id: number;
  group_name: string;
  min_age: number;
  max_age: number;
  start_date: string;
  start_time: string;
  end_time: string;
  number_of_lessons: string;
  price_type_id: string | null;
  value: string;
  program?: {
    id: number;
    name: string;
    title: string;
  };
  p_o_s?: {
    id: number;
    name: string;
    location: string;
  };
  [key: string]: any;
};

type ClassDetailsContextType = {
  classDetails: ClassDetailsType | null;
};

const ClassDetailsContext = createContext<ClassDetailsContextType>({
  classDetails: null,
});

export const ClassDetailsProvider = ({
  children,
  classDetails,
}: {
  children: React.ReactNode;
  classDetails: ClassDetailsType | null;
}) => {
  return (
    <ClassDetailsContext.Provider value={{ classDetails }}>
      {children}
    </ClassDetailsContext.Provider>
  );
};

export const useClassDetails = () => useContext(ClassDetailsContext);
